import { z } from 'zod';

import { makeEndpoint } from '../common';

export enum PaymentMethods {
  CREDIT_CARD = 'credit-card',
  ROOM_CHARGE = 'room-charge',
  MEMBER_NUMBER = 'member-number',
  LOYALTY = 'loyalty',
  KICC = 'kicc',
  CASH = 'cash',
  PAY_LATER = 'pay-later',
  PAY_UPON_ARRIVAL = 'pay-upon-arrival',
}

export const PaymentMethodNumberSchema = z.object({ number: z.string().trim().nonempty() });
export type PaymentMethodNumber = z.infer<typeof PaymentMethodNumberSchema>;

export const ImportPaymentMethodsRequestSchema = z.object({
  data: z.array(PaymentMethodNumberSchema),
});

export const DomainNameSchema = z.object({
  id: z.string(),
  domainName: z.string(),
  hasActiveApplePay: z.boolean(),
});

export type DomainNameData = z.infer<typeof DomainNameSchema>;

export const ValidatePaymentMethodDomainsEndpoint = makeEndpoint({
  url: ({ brandId }: { brandId: string }) => `v1/brands/${brandId}/validate-payment-method-domains`,
  method: 'POST',
  requestSchema: z.object({
    forceValidation: z.boolean()?.optional(),
  }),
  responseSchema: z.array(DomainNameSchema),
});
